import { render, staticRenderFns } from "./add_coupon1.vue?vue&type=template&id=a801207a&scoped=true"
import script from "./add_coupon1.vue?vue&type=script&lang=js"
export * from "./add_coupon1.vue?vue&type=script&lang=js"
import style0 from "./add_coupon1.vue?vue&type=style&index=0&id=a801207a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a801207a",
  null
  
)

export default component.exports